module.exports = __webpack_public_path__ + "img/attention.e17a74c9.svg";